<template>
  <div>
    <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/graph_pen_1.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div
              class="text-subtitle-2 text-md-h5"
              v-if="this.eventStatus === 'cancelled'"
            >
              {{ $t("cancelledtrainingevents") }}
            </div>
            <div
              class="text-subtitle-2 text-md-h5"
              v-if="this.eventStatus === 'drafted'"
            >
              {{ $t("draftedTrainingEvents") }}
            </div>
            <div
              class="text-subtitle-2 text-md-h5"
              v-if="this.eventStatus === 'archived'"
            >
              {{ $t("archivedTrainingEvents") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="omt-wrap">
      <div>
        <!-- Right Area -->
        <div class="hide">
          <v-checkbox
            v-model="onlyMyBookingsFilter"
            class="no-margin-top mt-4"
            :label="$t('only_my_trainings')"
            @click="fetchCancelledTrainingEvents()"
          ></v-checkbox>
        </div>
        <div class="row align-items-start event_table_btn pl-3">
          <div
            class="col-xl-6 right-side-block row"
            v-show="!$external && $rights.includes('CREATE_TRAINING_EVENT')"
          ></div>

          <div
            class="col-xl-6 right-side-block justify-content-right"
            id="buttons-custom-te"
          >
            <div class=""></div>
            <v-btn
              :to="`/training-events`"
              outlined
              depressed
              tile
              class="savebutton"
              >{{ $t("view_active_events") }}</v-btn
            >
            <v-btn
              v-if="columnSearch != null && filterTab"
              @click="clearFilters()"
              outlined
              depressed
              tile
              class="savebutton cl_filter_btn ml-2"
              ><v-icon>mdi-close</v-icon>{{ $t("clearFilters") }}</v-btn
            >
          </div>
        </div>
      </div>

      <!-- Left Area -->

      <!-- Left Area -->
      <div class="grid-container">
        <ag-grid-vue
          class="ag-theme-alpine ag-custom-te ag-custom-tbl"
          id="myGrid"
          :columnDefs="columnDefs"
          @grid-ready="onGridReady"
          :rowData="rowData"
          :gridOptions="gridOptions"
          :domLayout="'autoHeight'"
          :pinnedBottomRowData="pinnedBottomRowData"
          :rowClassRules="rowClassRules"
          :isFullWidthCell="isFullWidthCell"
          @sortChanged="onSortChanged"
          @onFilterChanged="onFilterChanged"
          @cell-clicked="onCellClicked"
          @firstDataRendered="onFirstDataRendered"
          :suppressCellSelection="true"
          :headerHeight="40"
          :localeText="gridLocaleText"
        >
        </ag-grid-vue>
      </div>
      <span class="sppn"
        >{{ allCount > 0 ? page : 0 }}&nbsp;{{ this.$t("of") }}&nbsp;{{
          totalPages
        }}
        ({{ allCount }} {{ this.$t("records") }})
      </span>
      <pagination
        class="my-2"
        :current-page="page"
        :total-pages="totalPages"
        :show-previous-page="previousPage"
        :show-next-page="nextPage"
        :show-current-page="showCurrentPageAll"
      ></pagination>
    </div>
  </div>
</template>

<script>
import pagination from "./custom/pagination.vue";
import { AgGridVue } from "ag-grid-vue";
const _ = require("lodash");
import ColumnHeaderSearch from "./custom/ColumnHeaderSearch.vue";
import ColumnDateSearch from "./custom/ColumnDateSearch.vue";
import ColumnDropDownSearch from "./custom/ColumnDropDownSearch.vue";
import ColumnAutoCompleteSearch from "./custom/ColumnAutoCompleteSearch.vue";
import ColumnCustomerDropDownSearch from "./custom/ColumnCustomerDropDownSearch.vue";

import { eventBus } from "../main.js";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    AgGridVue,
    pagination,
    columnHeaderSearch: ColumnHeaderSearch,
    columnDateSearch: ColumnDateSearch,
    columnDropDownSearch: ColumnDropDownSearch,
    columnAutoCompleteSearch: ColumnAutoCompleteSearch,
    Breadcrumb,
    columnCustomerDropDownSearch: ColumnCustomerDropDownSearch,
  },

  data() {
    return {
      vehicleType: null,
      stickyThreshold: 750, // Adjust this value if needed
      dtOrder: "N",
      createmode: true,
      allCount: 0,
      gridOptions: {
        suppressContextMenu: true,
        rowModelType: "clientSide",
        suppressMovableColumns: true, // Suppress column shifting
        rowHeight: 120,
        rowClass: "custom-row",
        suppressMenuHide: true,
        enableColResize: true,
        ensureDomOrder: true,
      },
      gridApi: null,
      columnApi: null,
      rowData: [],
      pinnedBottomRowData: null,
      rowClassRules: null,
      isFullWidthCell: null,
      frameworkComponents: null,
      eventStatus: "normal",
      page: 1,
      totalPages: 1,
      ElementPerPage: 50,
      sort: null,
      order: false,
      routes: {
        trainingEvents: "/api/training/event",
        filter: "/api/training/event/search/",
      },
      search: "",
      convertedTrainingEvents: [],
      trainingEventFilter: null,
      trainerFilter: null,
      onlyMyBookingsFilter: false,
      trainers: [],

      rules: [(value) => !!value || this.$t("required")],
      trainingEvents: [],
      roles: [],
      createTrainingEventPopup: false,
      createmode: true,

      // Personal Data
      me: null,

      trainersFetched: false,
      columnHeader: null,
      columnSearch: null,
      startDate: null,
      endDate: null,
      eventNumber: null,
      locationFormatted: null,
      name: null,
      freeSpaces: null,
      status: null,
      trainingname: null,
      eventTrainingname: null,
    };
  },

  created() {
    if (this.$route.query.eventStatus === "cancelled") {
      this.eventStatus = "cancelled";
    } else if (this.$route.query.eventStatus === "drafted") {
      this.eventStatus = "drafted";
    } else if (this.$route.query.eventStatus === "archived") {
      this.eventStatus = "archived";
    } else {
      this.eventStatus = "normal";
    }
  },
  computed: {
    gridLocaleText() {
      return {
        noRowsToShow: this.$t("noRowsToShow"),
      };
    },
    selectableExamTypes() {
      return [
        { value: "ORAL", text: this.$t("practical_exam") },
        { value: "THEORETICAL", text: this.$t("theoretical_exam") },
        {
          value: "ORAL_AND_THEORETICAL",
          text: this.$t("practical_and_theoretical_exam"),
        },
        {
          value: "ORAL_THEORETICAL",
          text: this.$t("practical_theoretical_exam"),
        },
        {
          value: "THEORETICAL_THEORETICAL",
          text: this.$t("theoretical_and_theoretical_exam"),
        },
        { value: "ORAL_ORAL", text: this.$t("practical_and_practical_exam") },
        {
          value: "ORAL_ORAL_AND_THEORETICAL",
          text: this.$t("practical_practical_and_theoretical_exam"),
        },
        {
          value: "ORAL_ORAL_AND_ORAL",
          text: this.$t("practical_practical_and_practical_exam"),
        },
        {
          value: "THEORETICAL_THEORETICAL_AND_ORAL",
          text: this.$t("theoretical_theoretical_and_practical_exam"),
        },
        {
          value: "THEORETICAL_THEORETICAL_AND_THEROTICAL",
          text: this.$t("theoretical_theoretical_and_theoretical_exam"),
        },
      ];
    },
    statusOptions1() {
      return [
        { text: this.$t("currentEvents"), value: "C" },
        { text: this.$t("pastEvents"), value: "P" },
        { text: this.$t("upcomingEvents"), value: "F" },
        { text: this.$t("allEvents"), value: "N" },
      ];
    },
    types() {
      return [
        { value: "PRESENCE", text: this.$t("PRESENCE") },
        { value: "VIDEO", text: this.$t("VIDEO") },
        { value: "VIRTUAL", text: this.$t("VIRTUAL") },
        {
          value: "PRESENCE_AND_VIRTUAL",
          text: this.$t("PRESENCE_AND_VIRTUAL"),
        },
      ];
    },

    columnDefs() {
      return [
        {
          id: 1,
          order: 1,
          field: "eventNumber",
          flex: 2,
          minWidth: 120,
          wrapText: true,
          autoHeight: true,
          sortable: true,
          cellRenderer: this.designationsFieldEventNumber,
          headerName: this.$t("eventNr"),
          cellClass: "ag-cell cell_1",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "eventNumberEventInactive",
          },
        },

        {
          id: 2,
          order: 2,
          field: "startDate",
          flex: 2,
          minWidth: 120,
          wrapText: true,
          autoHeight: true,
          sortable: true,
          cellRenderer: this.designationsFieldDate,
          headerName: this.$t("date"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateSearch",

          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "startDateEventInactive",
          },
        },

        {
          id: 3,
          order: 3,
          field: "training",
          flex: 3,
          minWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellRenderer: this.designationsField,
          sortable: false,
          headerName: this.$t("training"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "trainingnameInactive",
          },
        },

        {
          id: 4,
          order: 4,
          field: "eventTrainingCategory",
          flex: 4,
          minWidth: 220,
          wrapText: true,
          autoHeight: true,
          cellRenderer: this.designationsFieldCategory,
          sortable: false,
          headerName: this.$t("training_event_category"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "eventTrainingCategoryNameInactive",
          },
        },
        {
          id: 5,
          order: 5,
          wrapText: true,
          autoHeight: true,
          field: "vehicleType",
          flex: 2,
          minWidth: 117,
          sortable: false,
          headerName: this.$t("vehicleType"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "vehicleTypeInactive",
          },
        },
        {
          id: 6,
          order: 6,
          wrapText: true,
          autoHeight: true,
          field: "locationFormatted",
          flex: 2,
          minWidth: 140,
          sortable: false,
          cellRenderer: this.locationfiled,
          headerName: this.$t("location"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "locationFormattedInactive",
          },
        },
        {
          id: 7,
          order: 7,
          field: "tenant.name",
          flex: 2,
          minWidth: 120,
          sortable: false,
          wrapText: true,
          autoHeight: true,
          headerName: this.$t("customer"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnCustomerDropDownSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnCustomerDropDownSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "nameInactive",
          },
        },
        {
          id: 8,
          order: 8,
          field: "trainers",
          flex: 2,
          minWidth: 140,
          sortable: false,
          wrapText: true,
          autoHeight: true,
          headerName: this.$t("trainer"),
          cellRenderer: this.designationsFieldTrainer,
          cellClass: "ag-cell",
          headerClass: "ag-cell trainerColmn",
          suppressMenu: true,
          filterFramework: "columnAutoCompleteSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnAutoCompleteSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "trainersInactive",
          },
        },
        {
          id: 9,
          order: 9,
          flex: 2,
          minWidth: 140,
          wrapText: true,
          autoHeight: true,
          field: "status",
          sortable: false,
          headerName: this.$t("status"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          cellRenderer: this.getStatusWithHighlight,
          suppressMenu: true,
          filterFramework: "columnDropDownSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDropDownSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "statusInactive",
          },
        },
      ];
    },
  },
  updated() {
    if (this.$user != null && !this.trainersFetched) {
      this.fetchTrainers();
      this.trainersFetched = true;
    }
  },

  beforeMount() {
    this.gridOptions = {};
    this.fetchTrainers();
  },
  beforeDestroy() {
    // Clean up the scroll event listener
    window.removeEventListener("scroll", this.handlePageScroll);
  },
  mounted() {
    window.addEventListener("scroll", this.handlePageScroll);

    if (
      !sessionStorage.getItem("startDateEventInactive") &&
      !sessionStorage.getItem("eventNumberEventInactive") &&
      !sessionStorage.getItem("trainingnameInactive") &&
      !sessionStorage.getItem("eventTrainingCategoryNameInactive") &&
      !sessionStorage.getItem("vehicleTypeInactive") &&
      !sessionStorage.getItem("locationFormattedInactive") &&
      !sessionStorage.getItem("trainersInactive") &&
      !sessionStorage.getItem("nameInactive") &&
      !sessionStorage.getItem("statusInactive")
    ) {
      sessionStorage.removeItem("filterInactive");
      this.filterTab = false;
    } else {
      this.filterTab = true;
      sessionStorage.setItem("filterInactive", "filter");
    }
    if (sessionStorage.getItem("filterInactive")) {
      this.filterTab = true;
      this.columnSearch = true;
      if (this.eventStatus == "archived") {
        this.fetchArchivedTrainingEvents_getData();
      } else {
        this.fetchCancelledTrainingEvents_getData();
      }
    } else {
      this.filterTab = false;
      this.columnSearch = false;
      if (this.eventStatus == "archived") {
        this.fetchArchivedTrainingEventsNoFilter();
      } else {
        this.fetchCancelledTrainingEventsNoFilter();
      }
    }
  },
  methods: {
    fetchArchivedTrainingEvents_getData() {
      this.eventNumber =
        !sessionStorage.getItem("eventNumberEventInactive") ||
        sessionStorage.getItem("eventNumberEventInactive").trim() === ""
          ? null
          : sessionStorage.getItem("eventNumberEventInactive");

      this.startDate =
        !sessionStorage.getItem("startDateEventInactive") ||
        sessionStorage.getItem("startDateEventInactive").trim() === ""
          ? null
          : sessionStorage.getItem("startDateEventInactive");

      this.trainingname =
        !sessionStorage.getItem("trainingnameInactive") ||
        sessionStorage.getItem("trainingnameInactive").trim() === ""
          ? null
          : sessionStorage.getItem("trainingnameInactive");

      this.eventTrainingname =
        !sessionStorage.getItem("eventTraningCategoryNameInactive") ||
        sessionStorage.getItem("eventTraningCategoryNameInactive").trim() === ""
          ? null
          : sessionStorage.getItem("eventTraningCategoryNameInactive");

      this.vehicleType =
        !sessionStorage.getItem("vehicleTypeInactive") ||
        sessionStorage.getItem("vehicleTypeInactive").trim() === ""
          ? null
          : sessionStorage.getItem("vehicleTypeInactive");

      this.trainers =
        !sessionStorage.getItem("trainersInactive") ||
        sessionStorage.getItem("trainersInactive").trim() === ""
          ? null
          : sessionStorage.getItem("trainersInactive");

      this.locationFormatted = !sessionStorage.getItem(
        "locationFormattedInactive"
      )
        ? null
        : sessionStorage.getItem("locationFormattedInactive");

      this.status =
        !sessionStorage.getItem("statusInactive") ||
        sessionStorage.getItem("statusInactive").trim() === ""
          ? null
          : sessionStorage.getItem("statusInactive");

      this.name =
        !sessionStorage.getItem("nameInactive") ||
        sessionStorage.getItem("nameInactive").trim() === ""
          ? null
          : sessionStorage.getItem("nameInactive").trim().toLowerCase();

      this.page = 1;
      this.fetchArchivedTrainingEvents();
    },
    fetchCancelledTrainingEvents_getData() {
      this.eventNumber =
        !sessionStorage.getItem("eventNumberEventInactive") ||
        sessionStorage.getItem("eventNumberEventInactive").trim() === ""
          ? null
          : sessionStorage.getItem("eventNumberEventInactive");

      this.startDate =
        !sessionStorage.getItem("startDateEventInactive") ||
        sessionStorage.getItem("startDateEventInactive").trim() === ""
          ? null
          : sessionStorage.getItem("startDateEventInactive");

      this.trainingname =
        !sessionStorage.getItem("trainingnameInactive") ||
        sessionStorage.getItem("trainingnameInactive").trim() === ""
          ? null
          : sessionStorage.getItem("trainingnameInactive");

      this.eventTrainingname =
        !sessionStorage.getItem("eventTrainingCategoryNameInactive") ||
        sessionStorage.getItem("eventTrainingCategoryNameInactive").trim() ===
          ""
          ? null
          : sessionStorage.getItem("eventTrainingCategoryNameInactive");

      this.vehicleType =
        !sessionStorage.getItem("vehicleTypeInactive") ||
        sessionStorage.getItem("vehicleTypeInactive").trim() === ""
          ? null
          : sessionStorage.getItem("vehicleTypeInactive");

      this.trainerFilter =
        !sessionStorage.getItem("trainersInactive") ||
        sessionStorage.getItem("trainersInactive").trim() === ""
          ? null
          : sessionStorage.getItem("trainersInactive");

      this.locationFormatted = !sessionStorage.getItem(
        "locationFormattedInactive"
      )
        ? null
        : sessionStorage.getItem("locationFormattedInactive");

      this.status =
        !sessionStorage.getItem("statusInactive") ||
        sessionStorage.getItem("statusInactive").trim() === ""
          ? null
          : sessionStorage.getItem("statusInactive");

      this.name =
        !sessionStorage.getItem("nameInactive") ||
        sessionStorage.getItem("nameInactive").trim() === ""
          ? null
          : sessionStorage.getItem("nameInactive").trim().toLowerCase();

      this.page = 1;
      this.fetchCancelledTrainingEvents();
    },
    handlePageScroll() {
      const gridHeader = document.querySelector(".ag-header");
      const gridContainer = document.querySelector(".grid-container");

      if (gridHeader) {
        const scrollPosition =
          window.scrollY || document.documentElement.scrollTop;

        if (scrollPosition > this.stickyThreshold) {
          gridHeader.classList.add("header_stick");

          // Add the .grid_stick class to the .grid-container when the header is sticky
          if (gridContainer) {
            gridContainer.classList.add("grid_stick");
          }
        } else {
          gridHeader.classList.remove("header_stick");

          // Remove the .grid_stick class when the header is no longer sticky
          if (gridContainer) {
            gridContainer.classList.remove("grid_stick");
          }
        }
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit(); // Resize columns to fit the grid width
    },
    designationsFieldEventNumber(params) {
      const eventNumber = params.data.eventNumber || "";
      const type =
        this.types.find((t) => t.value === params.data.eventType)?.text || "";

      const container = document.createElement("div");
      if (type) {
        container.innerHTML = `
          <div style="display: flex;gap: 5px;align-items: center;margin-bottom: 5px;">
          <div style="font-size: 14px; line-height: 19px; color: #5B5B5B; font-weight: 400;">
            ${eventNumber}
          </div>
          <div class="open-event" style="cursor: pointer;">
           <img src="/static/img/onw.png" style="opacity:0.5;">
          </div>
          </div>
          <div class="event-type-text">${type}</div>
        `;
      } else {
        container.innerHTML = `
         <div style="display: flex;gap: 5px;align-items: center;margin-bottom: 5px;">
          <div style="font-size: 14px; line-height: 19px; color: #5B5B5B; font-weight: 400;">
            ${eventNumber}
          </div>
          <div class="open-event" style="cursor: pointer;">
           <img src="/static/img/onw.png" style="opacity:0.5;">
          </div>
          </div>
        `;
      }

      const iconEl = container.querySelector(".open-event");
      iconEl.addEventListener("click", (e) => {
        e.stopPropagation(); // Prevent AG Grid from firing cellClicked
        this.onCellClickedNewWindow(params); // Open in new tab
      });

      return container;
    },
    onCellClickedNewWindow(params) {
      const rowData = params.data;

      if (this.$user.onlySalesPerson) {
        return;
      }

      const url = this.$router.resolve({
        path: "/edit-training-event",
        query: {
          trainingEventId: rowData.id,
          eventStatus: this.eventStatus,
        },
      }).href;

      window.open(url, "_blank");
    },

    designationsFieldDate(params) {
      if (params.data.eventNumber) {
        if (params.data.startDate) {
          return `<div class="event-start-date">${params.data.startDateFormatted}</div><div class="practical_theoretical_wrap">${params.data.daysFormatted}</div> `;
        }
        if (
          params.data.startDate_PR_1 ||
          params.data.startDate_PR_2 ||
          params.data.startDate_PR_3 ||
          params.data.startDate_TH_1 ||
          params.data.startDate_TH_2 ||
          params.data.startDate_TH_3
        ) {
          let formattedDates = "";

          if (params.data.startDate_TH_1) {
            formattedDates += `<div class="event-start-date">${params.data.startDateFormatted_TH_1}</div><div class="practical_theoretical_wrap">${params.data.daysFormatted_TH_1}</div>`;
          }

          if (params.data.startDate_TH_2) {
            formattedDates += `<div class="event-start-date">${params.data.startDateFormatted_TH_2}</div><div class="practical_theoretical_wrap">${params.data.daysFormatted_TH_2}</div>`;
          }

          if (params.data.startDate_TH_3) {
            formattedDates += `<div class="event-start-date">${params.data.startDateFormatted_TH_3}</div><div class="practical_theoretical_wrap">${params.data.daysFormatted_TH_3}</div>`;
          }

          if (params.data.startDate_PR_1) {
            formattedDates += `<div class="event-start-date">${params.data.startDateFormatted_PR_1}</div><div class="practical_theoretical_wrap">${params.data.daysFormatted_PR_1}</div>`;
          }

          if (params.data.startDate_PR_2) {
            formattedDates += `<div class="event-start-date">${params.data.startDateFormatted_PR_2}</div><div class="practical_theoretical_wrap">${params.data.daysFormatted_PR_2}</div>`;
          }

          if (params.data.startDate_PR_3) {
            formattedDates += `<div class="event-start-date">${params.data.startDateFormatted_PR_3}</div><div class="practical_theoretical_wrap">${params.data.daysFormatted_PR_3}</div>`;
          }

          return formattedDates; // Return the formatted dates as a single HTML string
        }
      }
    },

    clickFilterDropdown() {
      //this.fetchCancelledTrainingEvents();
      if (this.eventStatus == "archived") {
        this.fetchArchivedTrainingEvents();
      } else {
        this.fetchCancelledTrainingEvents();
      }
    },
    getRowHeight(params) {
      return 130;
    },

    designationsField(params) {
      if (params.data.training) {
        const locale = this.$i18n.locale;
        const trainingDesignation =
          params.data.training.designationsMap &&
          params.data.training.designationsMap[locale]
            ? params.data.training.designationsMap[locale]
            : "";
        if (params.data.examType) {
          const selectedExamType = this.selectableExamTypes.find(
            (type) => type.value === params.data.examType
          );
          const examTypeText = selectedExamType ? selectedExamType.text : "";
          return `<div style="font-size: 14px; line-height: 19px; color: #5B5B5B; padding-bottom: 5px;">${trainingDesignation}</div>
          <div class="event-type-text">${examTypeText}</div>
          `;
        } else {
          return `<div style="font-size: 14px; line-height: 14px; color: rgba(0, 0, 0, 0.50); padding-bottom: 5px;">${trainingDesignation}</div>`;
        }
      }
    },
    designationsFieldCategory(params) {
      if (params.data.trainingEventCategory) {
        const locale = this.$i18n.locale;
        const trainingDesignation =
          params.data.trainingEventCategory &&
          params.data.trainingEventCategory.designationsMap[locale]
            ? params.data.trainingEventCategory.designationsMap[locale]
            : "";
        if (params.data.examType) {
          const selectedExamType = this.selectableExamTypes.find(
            (type) => type.value === params.data.examType
          );
          const examTypeText = selectedExamType ? selectedExamType.text : "";
          return `<div style="font-size: 14px; line-height: 20px; color: #5b5b5b; padding-bottom: 5px;">${trainingDesignation}</div>
          <div class="event-type-text">${examTypeText}</div>
          `;
        } else {
          return `<div style="font-size: 14px; line-height: 20px; color: #5b5b5b; padding-bottom: 5px;">${trainingDesignation}</div>`;
        }
      }
    },

    locationfiled(params) {
      if (params.data.locationFormatted) {
        return `<div style="font-size: 14px; line-height: 20px; color: #5b5b5b; padding-bottom: 5px;">${params.data.locationFormatted}</div>`;
      }

      if (
        params.data.locationFormatted_PR_1 ||
        params.data.locationFormatted_PR_2 ||
        params.data.locationFormatted_PR_3 ||
        params.data.locationFormatted_TH_1 ||
        params.data.locationFormatted_TH_2 ||
        params.data.locationFormatted_TH_3
      ) {
        let formattedLocation = "";
        if (params.data.locationFormatted_PR_1) {
          formattedLocation += `<div>${params.data.locationFormatted_PR_1}</div>`;
        }

        if (params.data.locationFormatted_PR_2) {
          formattedLocation += `<div>${params.data.locationFormatted_PR_2}</div>`;
        }

        if (params.data.locationFormatted_PR_3) {
          formattedLocation += `<div>${params.data.locationFormatted_PR_3}</div>`;
        }
        if (params.data.locationFormatted_TH_1) {
          formattedLocation += `<div>${params.data.locationFormatted_TH_1}</div>`;
        }

        if (params.data.locationFormatted_TH_2) {
          formattedLocation += `<div>${params.data.locationFormatted_TH_2}</div>`;
        }

        if (params.data.locationFormatted_TH_3) {
          formattedLocation += `<div>${params.data.locationFormatted_TH_3}</div>`;
        }
        return formattedLocation;
      }
    },

    designationsFieldTrainer(params) {
      if (params.data.trainers) {
        const myArray = params.data.trainers.split("&");
        let trainerName = "";
        trainerName += "1. " + myArray[0] + "</br>";
        if (myArray[1]) {
          trainerName += "2. " + myArray[1] + "</br>";
        }
        if (myArray[2]) {
          trainerName += "3. " + myArray[2];
        }
        return `<div style="font-size: 14px; line-height: 19px; color: #5B5B5B; padding-bottom: 5px;">${trainerName}</div>`;
      }
    },
    hideTrainers() {
      if (this.$user.external) {
        const columnIndexToHide = this.columnDefs.findIndex(
          (column) => column.field === "trainers"
        );

        this.columnDefs[columnIndexToHide].hide = true;

        this.gridOptions.api.setColumnDefs(this.columnDefs);
        this.gridOptions.api.sizeColumnsToFit();
      }
      if (this.$user.external) {
        this.hideCustomers();
      }
    },

    hideCustomers() {
      if (
        this.$user.external ||
        !this.$rights.includes("CREATE_TRAINING_EVENT") ||
        this.$user.external
      ) {
        const columnIndexToHide = this.columnDefs.findIndex(
          (column) => column.field === "tenant.name"
        );

        this.columnDefs[columnIndexToHide].hide = true;
        this.gridOptions.api.setColumnDefs(this.columnDefs);
        this.gridOptions.api.sizeColumnsToFit();
      }
    },
    getStatusWithHighlight(params) {
      const status = params.data.status;
      let text = status;
      if (text === null) {
        text = "";
      }
      let imageUrl;
      let bgColor;

      if (status === "BOOKABLE") {
        text = this.$t("open");
        imageUrl = "/static/img/close-img.svg"; // Replace with your actual image path for open status
        bgColor = "background-green"; // Class for green background
      } else if (status === "CLOSED") {
        text = this.$t("closed");
        imageUrl = "/static/img/open-img.svg"; // Replace with your actual image path for closed status
        bgColor = "background-red"; // Class for red background
      }

      const freeSpaces = params.data.freeSpaces;
      const colorClass = freeSpaces <= 0 ? "text-danger" : "text-success";

      return `<div class="status-wrapper ${bgColor}">
            <span>
              <img src="${imageUrl}" class="status-icon" />
              ${text}
            </span>
            <span style="font-size: 12px" class="${colorClass}">
              (${freeSpaces})
            </span>
          </div>`;
    },
    onFilterChanged(columnHeader, columnSearch) {
      this.page = 1;
      this.columnHeader = columnHeader;
      this.columnSearch = columnSearch;
      if (this.columnHeader === "startDateEventInactive") {
        this.startDate = this.columnSearch;
      }
      if (this.columnHeader === "trainingnameInactive") {
        this.trainingname = this.columnSearch;
      }

      if (this.columnHeader === "endDateInactive") {
        this.endDate = this.columnSearch;
      }
      if (this.columnHeader === "trainersInactive") {
        this.trainerFilter = this.columnSearch;
      }
      if (this.columnHeader === "eventNumberEventInactive") {
        this.eventNumber = this.columnSearch;
      }

      if (this.columnHeader === "eventTrainingCategoryNameInactive") {
        this.eventTrainingname = this.columnSearch;
      }

      if (this.columnHeader === "vehicleTypeInactive") {
        this.vehicleType = this.columnSearch;
      }

      if (this.columnHeader === "locationFormattedInactive") {
        this.locationFormatted = this.columnSearch;
      }
      if (this.columnHeader === "nameInactive") {
        this.name = this.columnSearch;
      }
      if (this.columnHeader === "freeSpacesInactive") {
        this.freeSpaces = this.columnSearch;
      }
      if (this.columnHeader === "statusInactive") {
        this.status = this.columnSearch;
      }
      this.startDate =
        this.startDate === null || this.startDate.trim() === ""
          ? null
          : this.startDate;
      this.endDate =
        this.endDate === null || this.endDate.trim() === ""
          ? null
          : this.endDate;
      this.eventNumber =
        this.eventNumber === null || this.eventNumber.trim() === ""
          ? null
          : this.eventNumber;
      this.locationFormatted =
        this.locationFormatted === null || this.locationFormatted.trim() === ""
          ? null
          : this.locationFormatted;

      this.name = !this.name ? null : this.name;

      this.freeSpaces =
        this.freeSpaces === null || this.freeSpaces.trim() === ""
          ? null
          : this.freeSpaces;
      this.status =
        this.status === null || this.status.trim() === "" ? null : this.status;
      this.trainingname =
        this.trainingname === null || this.trainingname.trim() === ""
          ? null
          : this.trainingname;

      this.eventTrainingname =
        this.eventTrainingname === null || this.eventTrainingname.trim() === ""
          ? null
          : this.eventTrainingname;

      this.vehicleType =
        this.vehicleType === null || this.vehicleType.trim() === ""
          ? null
          : this.vehicleType;

      this.trainerFilter =
        this.trainerFilter === null ? null : this.trainerFilter;

      if (
        !this.startDate &&
        !this.eventNumber &&
        !this.locationFormatted &&
        !this.name &&
        !this.status &&
        !this.trainingname &&
        !this.eventTrainingname &&
        !this.trainerFilter &&
        !this.vehicleType
      ) {
        this.filterTab = false;
      } else {
        this.columnSearch = true;
        this.filterTab = true;
      }

      //this.fetchCancelledTrainingEvents();
      if (this.eventStatus == "archived") {
        this.fetchArchivedTrainingEvents();
      } else {
        this.fetchCancelledTrainingEvents();
      }
    },
    clearFilters() {
      eventBus.$emit("clear-filters");
      this.columnHeader = null;
      this.columnSearch = null;
      this.startDate = null;
      this.endDate = null;
      this.eventNumber = null;
      this.locationFormatted = null;
      this.name = null;
      this.freeSpaces = null;
      this.status = null;
      this.trainingname = null;
      this.trainerFilter = null;
      this.eventTrainingname = null;
      this.vehicleType = null;
      this.locationFormatted = null;
      this.trainer = null;
      this.eventNumber = null;
      // this.fetchCancelledTrainingEvents();

      sessionStorage.removeItem("activeTab");
      sessionStorage.removeItem("filterInactive");
      sessionStorage.removeItem("startDateEventInactive");
      sessionStorage.removeItem("eventNumberEventInactive");
      sessionStorage.removeItem("trainingnameInactive");
      sessionStorage.removeItem("eventTrainingCategoryNameInactive");
      sessionStorage.removeItem("vehicleTypeInactive");
      sessionStorage.removeItem("locationFormattedInactive");
      sessionStorage.removeItem("trainersInactive");
      sessionStorage.removeItem("nameInactive");
      sessionStorage.removeItem("statusInactive");

      this.filterTab = false;

      if (this.eventStatus == "archived") {
        this.fetchArchivedTrainingEvents();
      } else {
        this.fetchCancelledTrainingEvents();
      }
    },
    onCellClicked(params) {
      if (this.$user.onlySalesPerson) {
        return;
      }
      const rowData = params.data;
      this.$router.push(
        "/edit-training-event?trainingEventId=" +
          rowData.id +
          "&eventStatus=" +
          this.eventStatus
      );
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
      this.hideTrainers();
    },
    onSortChanged(event) {
      const allColumns = event.columnApi.getAllColumns();
      const sortableColumns = allColumns.filter(
        (col) => col.getColDef().sortable
      );

      if (sortableColumns.length > 0) {
        this.sortIncompleted = "";
        this.orderIncompleted = "";
        const sortedCol = sortableColumns.find((col) => col.getSort());
        if (sortedCol) {
          const sortState = sortedCol.getSort();
          let sortField = sortedCol.getColId();
          const sortOrder = sortState === "asc" ? "ASC" : "DESC";

          if (sortField == "startDate") {
            sortField = "startDate";
          }
          this.sort = sortField;
          this.order = sortOrder === "ASC";
          this.page = 1;
          if (this.eventStatus == "archived") {
            this.fetchArchivedTrainingEvents();
          } else {
            this.fetchCancelledTrainingEvents();
          }
        }
      }
    },
    previousPage() {
      this.page = this.page - 1;
      //this.fetchCancelledTrainingEvents();
      if (this.eventStatus == "archived") {
        this.fetchArchivedTrainingEvents();
      } else {
        this.fetchCancelledTrainingEvents();
      }
    },
    nextPage() {
      this.page = this.page + 1;
      //this.fetchCancelledTrainingEvents();
      if (this.eventStatus == "archived") {
        this.fetchArchivedTrainingEvents();
      } else {
        this.fetchCancelledTrainingEvents();
      }
    },
    showCurrentPageAll(pageNumber) {
      this.page = pageNumber;
      if (this.eventStatus == "archived") {
        this.fetchArchivedTrainingEvents();
      } else {
        this.fetchCancelledTrainingEvents();
      }
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchCancelledTrainingEvents() {
      var _this = this;
      this.$axios
        .get(this.routes.trainingEvents, {
          params: {
            search: _this.search,
            trainer: _this.trainerFilter,
            onlyMyBookings: _this.onlyMyBookingsFilter,
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage,
            startDate: _this.startDate,
            endDate: _this.endDate,
            eventNumber: _this.eventNumber,
            locationFormatted: _this.locationFormatted,
            name: _this.name,
            freeSpaces: _this.freeSpaces,
            status: _this.status,
            trainingname: _this.trainingname,
            eventTrainingname: _this.eventTrainingname,
            vehicleType: _this.vehicleType,
            eventflag:
              _this.eventStatus === "cancelled"
                ? "1"
                : _this.eventStatus === "drafted"
                ? "2"
                : "0",
            dtOrder: this.dtOrder,
          },
        })
        .then(function (response) {
          _this.trainingEvents = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.allCount = response.data.totalElements;
          _this.rowData = _.cloneDeep(_this.trainingEvents);
          _this.gridApi.setRowData(_this.rowData);
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchArchivedTrainingEvents() {
      var _this = this;
      this.eventStatus2 = "drafted";
      this.$axios
        .get(this.routes.trainingEvents, {
          params: {
            search: _this.search,
            trainer: _this.trainerFilter,
            onlyMyBookings: _this.onlyMyBookingsFilter,
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage,
            startDate: _this.startDate,
            endDate: _this.endDate,
            eventNumber: _this.eventNumber,
            locationFormatted: _this.locationFormatted,
            name: _this.name,
            freeSpaces: _this.freeSpaces,
            status: _this.status,
            trainingname: _this.trainingname,
            vehicleType: _this.vehicleType,
            eventflagArchived: "archived",
            dtOrder: "N",
          },
        })
        .then(function (response) {
          // _this.archivedEventCount=response.data.numberOfElements;
          _this.trainingEvents = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.allCount = response.data.totalElements;
          _this.rowData = _.cloneDeep(_this.trainingEvents);
          _this.gridApi.setRowData(_this.rowData);
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },

    fetchCancelledTrainingEventsNoFilter() {
      var _this = this;
      this.$axios
        .get(this.routes.trainingEvents, {
          params: {
            search: _this.search,
            trainer: _this.trainerFilter,
            onlyMyBookings: _this.onlyMyBookingsFilter,
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage,
            eventflag:
              _this.eventStatus === "cancelled"
                ? "1"
                : _this.eventStatus === "drafted"
                ? "2"
                : "0",
            dtOrder: this.dtOrder,
          },
        })
        .then(function (response) {
          _this.trainingEvents = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.allCount = response.data.totalElements;
          _this.rowData = _.cloneDeep(_this.trainingEvents);
          _this.gridApi.setRowData(_this.rowData);
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchArchivedTrainingEventsNoFilter() {
      var _this = this;
      this.eventStatus2 = "drafted";
      this.$axios
        .get(this.routes.trainingEvents, {
          params: {
            search: _this.search,
            trainer: _this.trainerFilter,
            onlyMyBookings: _this.onlyMyBookingsFilter,
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage,
            eventflagArchived: "archived",
            dtOrder: "N",
          },
        })
        .then(function (response) {
          // _this.archivedEventCount=response.data.numberOfElements;
          _this.trainingEvents = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.allCount = response.data.totalElements;
          _this.rowData = _.cloneDeep(_this.trainingEvents);
          _this.gridApi.setRowData(_this.rowData);
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },

    fetchTrainers() {
      var _this = this;
      this.$axios
        .get("/api/user/trainer")
        .then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            if (Number.isInteger(element)) {
              _this.fetchSingleTrainerAndPush(element);
            } else {
              _this.trainers.push(element);
            }
          }
        })
        .catch(this.onError);
    },

    fetchSingleTrainerAndPush(trainerId) {
      var _this = this;
      this.$axios
        .get("/api/user/" + trainerId)
        .then(function (response) {
          const element = response.data;
          _this.trainers.push(element);
        })
        .catch(this.onError);
    },
  },
};
</script>
